import { useTheme } from '@100mslive/react-ui';

const useDropdownSelection = () => {
    const { themeType } = useTheme();
    return themeType === 'dark' ? '$primaryDark' : '$grayLight';
};

export { useDropdownSelection };
